var _path, _path2, _path3, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 22L40 32",
    stroke: "#D8EAF9",
    strokeWidth: 0.899999,
    strokeLinecap: "round",
    strokeDasharray: "5.4 5.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22L14 32",
    stroke: "#D8EAF9",
    strokeWidth: 0.899999,
    strokeLinecap: "round",
    strokeDasharray: "5.4 5.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9847 17.4944C21.5322 16.2045 22.8104 15.2998 24.3 15.2998H29.7C31.1896 15.2998 32.4678 16.2045 33.0153 17.4944M30.6 8.5498C30.6 10.538 28.9882 12.1498 27 12.1498C25.0118 12.1498 23.4 10.538 23.4 8.5498C23.4 6.56158 25.0118 4.9498 27 4.9498C28.9882 4.9498 30.6 6.56158 30.6 8.5498ZM36 10.7998C36 15.7704 31.9706 19.7998 27 19.7998C22.0295 19.7998 18 15.7704 18 10.7998C18 5.82924 22.0295 1.7998 27 1.7998C31.9706 1.7998 36 5.82924 36 10.7998Z",
    stroke: "#1672BA",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2457_5873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.78468 49.8948C5.33217 48.6049 6.61045 47.7002 8.10001 47.7002H13.5C14.9896 47.7002 16.2678 48.6049 16.8153 49.8948M14.4 40.9502C14.4 42.9384 12.7882 44.5502 10.8 44.5502C8.81179 44.5502 7.20002 42.9384 7.20002 40.9502C7.20002 38.962 8.81179 37.3502 10.8 37.3502C12.7882 37.3502 14.4 38.962 14.4 40.9502ZM19.8 43.2002C19.8 48.1708 15.7706 52.2002 10.8 52.2002C5.82945 52.2002 1.80002 48.1708 1.80002 43.2002C1.80002 38.2296 5.82945 34.2002 10.8 34.2002C15.7706 34.2002 19.8 38.2296 19.8 43.2002Z",
    stroke: "#3E9BE4",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2457_5873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1846 49.8948C37.7321 48.6049 39.0104 47.7002 40.5 47.7002H45.9C47.3895 47.7002 48.6678 48.6049 49.2153 49.8948M46.8 40.9502C46.8 42.9384 45.1882 44.5502 43.2 44.5502C41.2118 44.5502 39.6 42.9384 39.6 40.9502C39.6 38.962 41.2118 37.3502 43.2 37.3502C45.1882 37.3502 46.8 38.962 46.8 40.9502ZM52.2 43.2002C52.2 48.1708 48.1705 52.2002 43.2 52.2002C38.2294 52.2002 34.2 48.1708 34.2 43.2002C34.2 38.2296 38.2294 34.2002 43.2 34.2002C48.1705 34.2002 52.2 38.2296 52.2 43.2002Z",
    stroke: "#3E9BE4",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2457_5873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6,
    height: 21.6,
    fill: "white",
    transform: "translate(1.52588e-05 32.4004)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2457_5873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6,
    height: 21.6,
    fill: "white",
    transform: "translate(32.4 32.4004)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralGroup);
export default __webpack_public_path__ + "static/media/referralGroup.1765855f3ec265cd17d5c6b399a9fd4d.svg";
export { ForwardRef as ReactComponent };